export default "__VITE_ASSET__60028ade__"